<template>
    <div class="backgroundcontainer">
        <div class="invisible-top"></div>
        <div class="successfailure vcore_container pe_container" v-if="this.emailVerficationStatus === 'Successful'">
            <div>
                <div class="center"> <img class="successfailure_image" title="Verification Successful"
                        src="@Shared/assets/images/successfailure-success.svg"> </div>

                <h1 class="form-title center">Your email was successfully verified</h1>
                <div class="form-description  center">
                    Log in to manage your notification settings in the Healthcare Management Portal or refresh your active
                    session to update your verification status.
                </div>
            </div>
            <div class="center">
                <SecondaryButton class="log-into-cc-btn" :text="'Log In to Commerce Connections'"
                    @clickHandler="CCloginClick" />
            </div>
        </div>
        <div class="successfailure vcore_container pe_container" v-if="this.emailVerficationStatus  === 'Unsuccessful'">
            <div>
                <div class="center"> <img class="successfailure_image" title="Verification Unsuccessful"
                        src="@Shared/assets/images/successfailure-failure.png">
                </div>

                <h1 class="form-title center">We were not able to verify your email</h1>
                <div class="form-description center">
                    Visit “Manage Notifications” in the Healthcare Management Portal to update your settings.
                </div>
            </div>
            <div class="center">
                <SecondaryButton class="log-into-cc-btn" :text="'Log In to Commerce Connections'"
                    @clickHandler="CCloginClick" />
            </div>
        </div>
        <div class="successfailure vcore_container pe_container" v-if="this.emailVerficationStatus === 'Expired'">
            <div>
                <div class="center"> <img class="successfailure_image" title="Verification Expired"
                        src="@Shared/assets/images/successfailure-expired.svg">
                </div>

                <h1 class="form-title center">Your verification link has expired</h1>
                <div class="form-description center">
                    Visit “Manage Notifications” in the Healthcare Management Portal to resend your verification email.
                </div>
            </div>
            <div class="center">
                <SecondaryButton class="log-into-cc-btn" :text="'Log In to Commerce Connections'"
                    @clickHandler="CCloginClick" />
            </div>

        </div>
        <div class="footer">
            <LandingPageFooter />
        </div>
    </div>
</template>

<script>
import SecondaryButton from "@Shared/components/SecondaryButton.vue";
import LandingPageFooter from "../components/LandingPage/LandingPageFooter";
import { mapGetters, mapActions } from "vuex";
export default {

    name: "Verifyyouremail",
    props: ["token"],
    data() {
        return {
            emailverificationstatus: this.emailVerficationStatus,         
        }

    },
   

    created() {
      
    this.emailverificationstatus = this.getinfo; // The $refs object is empty at this point
   
  },

    components: {
        SecondaryButton,
        LandingPageFooter,
    },
    computed: {

        ...mapGetters([
            "emailVerficationStatus"
        ]),

        getinfo() {          
            var tokenstring = this.token;          
            this.getTokenInfo(tokenstring);
           
            return this.emailVerficationStatus;
        },
    },

    methods: {
        ...mapActions([
            "getTokenInfo",
        ]),

        CCloginClick() {
            window.location = `${process.env.VUE_APP_COMMERCECONNECTIONS_PATH}`;
        },

    },

};

</script>

<style lang="scss" scoped>
.successfailure {
    padding-bottom: 100px;
    padding-top: 100px;
    background: var(--Interface-layer-01, #FFF);
    box-shadow: 0px 3px 1px -2px rgba(30, 30, 37, 0.10), 0px 2px 3px 0px rgba(30, 30, 37, 0.16);
    justify-content: center;
    align-items: center;

}
.successfailure_image {
    width: 100px;
    height: 100.001px;
    flex-shrink: 0;

}

.log-into-cc-btn {
    margin-top: 20px;
    align-items: center;
}

.backgroundcontainer {
    background: #F7F9FA;
    height: calc(100vh - 115px) !important;

    @media (max-height: $grid-breakpoint-sm) {
        height: 100% !important;
    }
}

.center {
    top: 50%;
    left: 50%;
    text-align: center;
    padding: 20px;

}

.footer{
    position: absolute;
    bottom: 0;
    width: 100%;
    @media (max-width: $grid-breakpoint-sm) {
        position: relative;
    }

    @media (max-height: $grid-breakpoint-sm) {
        position: relative;
    }
}

.invisible-top{
    background: #F7F9FA;
    height: 75px;
    @media (max-width: $grid-breakpoint-sm) {
        height: 0px;
    }
}
</style>